"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.slug = void 0;
const assert_1 = require("./assert");
function slug(length = 8, alphabet = 'qwertasdfgzxcvbyuiophjklnmQWERTASDFGZXCVBYUIOPHJKLNM0123456789') {
    (0, assert_1.assert)(Number.isInteger(length), 'A slug must have an integer length');
    (0, assert_1.assert)(length > 0, 'A slug must have a positive length');
    (0, assert_1.assert)(length < 100, 'A slug is currently limited to 100 characters'); // Are you *sure* you want more?
    const a = Array(length);
    for (let i = 0; i < length; i++) {
        a[i] = alphabet[Math.floor(Math.random() * alphabet.length)];
    }
    return a.join('');
}
exports.slug = slug;
//# sourceMappingURL=slug.js.map